import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { HaModalService } from "@ha/ui/common";
import { ApplicationListModalComponent, ApplicationListModalComponentData } from "@ha/ui/navigation";
import { PwaState } from "@ha/util/pwa";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { filter, map, startWith } from "rxjs/operators";

import { NewsSelectors } from "libs/feature/news/src/lib/news/states/news.selectors";
import { ApplicationPaths } from "../../../constants/application-paths";
import { SettingsState } from "../../../core/states/settings.state";
import { Settings } from "./../../models/settings.model";
import { CurrentUserState } from "./../../states/current-user.state";
import { HamburgerMenuStateActions } from "../../states/hamburger-menu.actions";
import { HamburgerMenuState } from "../../states/hamburger-menu.state";
import { ProfileStateActions } from "../../states/profile.actions";
import { ProfileState } from "../../states/profile.state";
import { MobileNavigationComponentAnimations } from "./mobile-navigation.component.animations";

@Component({
    selector: "app-mobile-navigation",
    templateUrl: "./mobile-navigation.component.html",
    styleUrls: ["./mobile-navigation.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [MobileNavigationComponentAnimations.slideTrigger],
})
export class MobileNavigationComponent {

    @Select(SettingsState.settings)
    public settings$: Observable<Settings>;

    @Select(CurrentUserState.showLinkToAdmin)
    public showLinkToAdmin$: Observable<boolean>;

    @Select(CurrentUserState.isHotworker)
    public isHotworker$: Observable<boolean>;

    @Select(CurrentUserState.isEducationParticipant)
    public isEducationParticipant$: Observable<boolean>;

    @Select(CurrentUserState.isExternal)
    public isExternal$: Observable<boolean>;

    @Select(HamburgerMenuState.menuVisible)
    public menuVisible$: Observable<boolean>;

    @Select(ProfileState.menuOpen)
    public profileMenuVisible$: Observable<boolean>;

    @Select(PwaState.isMobile)
    public isMobile$: Observable<boolean>;

    @Select(NewsSelectors.unseenNewsCount)
    public unseenNewsCount$: Observable<number>;

    public showBottomMenu$ = this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null),
        map(() => !this.hideNavForPermitRoute(this.router.url)),
    );

    public applicationPaths = ApplicationPaths;

    constructor(private modalService: HaModalService, private store: Store, private router: Router) {}

    public openApplicationModal(): void {
        const applicationList = this.store.selectSnapshot(SettingsState.applicationList);
        this.modalService.open(
            ApplicationListModalComponent,
            true,
            <ApplicationListModalComponentData> { applicationList: applicationList },
        );
    }

    public toggleHamburgerMenu(): void {
        this.store.dispatch(new HamburgerMenuStateActions.ToggleMenu());
    }

    public hideAllMenus(): void {
        this.store.dispatch(new HamburgerMenuStateActions.HideAll());
        this.store.dispatch(new ProfileStateActions.HideMenu());
    }

    private hideNavForPermitRoute(url: string): boolean {
         const [, permit, id] = new URL(url, window.location.origin)
        .pathname
        .split("/");

        return (
            permit === ApplicationPaths.Permit.Root &&
            /^\d+$/.test(id ?? "")
        );
    }
}
